import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/staff/Dashboard';
import AdBlue from './pages/staff/AdBlue';
import CombustibleAdBlue from './pages/staff/CombustibleAdBlue';
import Combustible from './pages/staff/Combustible';
import Servicios from './pages/staff/Servicios';
import ServiciosPredefinidos from './pages/staff/ServiciosPredefinidos';
import Partes from './pages/staff/Partes';
import Maquinistas from './pages/staff/Maquinistas';
import Plantilla from './pages/staff/Plantilla';
import Calendario from './pages/staff/Calendario';
import FichaMaquinista from './pages/staff/FichaMaquinista';
import Flota from './pages/staff/Flota';
import MapaFlota from './pages/staff/MapaFlota';
import ConsultaTren from './pages/staff/ConsultaTren';
import ServicioDetalle from './pages/staff/ServicioDetalle';
import DocumentacionStaff from './pages/staff/Documentacion';
import LocomotoraDet from './pages/staff/LocomotoraDet';
import HistorialFlota from './pages/staff/HistorialFlota';
import GestionFlota from './pages/staff/GestionFlota';
import Inicio from './pages/maquinista/Inicio';
import ProximosServicios from './pages/maquinista/ProximosServicios';
import Habilitaciones from './pages/maquinista/Habilitaciones';
import Documentacion from './pages/maquinista/Documentacion';
import LayoutMaquinista from './components/layout/LayoutMaquinista';
import Servicio from './pages/maquinista/Servicio';

function PrivateRoute({ children, rol }) {
  const { usuario, loading } = useAuth();
  if (loading) return <div style={{ position: 'fixed', inset: 0, background: '#f5f4f0' }} />;
  if (!usuario) return <Navigate to="/login" replace />;
  if (rol === 'staff' && usuario.rol !== 'staff') return <Navigate to="/maquinista/nuevo-servicio" replace />;
  if (rol === 'maquinista' && usuario.rol === 'staff') return <Navigate to="/staff/dashboard" replace />;
  return rol === 'staff' ? <Layout>{children}</Layout> : <>{children}</>;
}

function AppRoutes() {
  const { usuario } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/staff/dashboard" element={<PrivateRoute rol="staff"><Dashboard /></PrivateRoute>} />
      <Route path="/staff/flota" element={<PrivateRoute rol="staff"><Flota /></PrivateRoute>} />
      <Route path="/staff/mapa-flota" element={<PrivateRoute rol="staff"><MapaFlota /></PrivateRoute>} />
      <Route path="/staff/consulta-tren" element={<PrivateRoute rol="staff"><ConsultaTren /></PrivateRoute>} />
      <Route path="/staff/documentacion" element={<PrivateRoute rol="staff"><DocumentacionStaff /></PrivateRoute>} />
      <Route path="/staff/servicio/:id" element={<PrivateRoute rol="staff"><ServicioDetalle /></PrivateRoute>} />
      <Route path="/staff/locomotora/:id" element={<PrivateRoute rol="staff"><LocomotoraDet /></PrivateRoute>} />
      <Route path="/staff/historial-flota" element={<PrivateRoute rol="staff"><HistorialFlota /></PrivateRoute>} />
      <Route path="/staff/gestion-flota" element={<PrivateRoute rol="staff"><GestionFlota /></PrivateRoute>} />
      <Route path="/staff/combustible-adblue" element={<PrivateRoute rol="staff"><CombustibleAdBlue /></PrivateRoute>} />
      <Route path="/staff/adblue" element={<PrivateRoute rol="staff"><AdBlue /></PrivateRoute>} />
      <Route path="/staff/combustible" element={<PrivateRoute rol="staff"><Combustible /></PrivateRoute>} />
      <Route path="/staff/servicios" element={<PrivateRoute rol="staff"><Servicios /></PrivateRoute>} />
      <Route path="/staff/servicios-predefinidos" element={<PrivateRoute rol="staff"><ServiciosPredefinidos /></PrivateRoute>} />
      <Route path="/staff/partes" element={<PrivateRoute rol="staff"><Partes /></PrivateRoute>} />
      <Route path="/staff/maquinistas" element={<PrivateRoute rol="staff"><Plantilla /></PrivateRoute>} />
      <Route path="/staff/calendario" element={<PrivateRoute rol="staff"><Calendario /></PrivateRoute>} />
      <Route path="/staff/maquinista/:id" element={<PrivateRoute rol="staff"><FichaMaquinista /></PrivateRoute>} />
      <Route path="/staff/admin-usuarios" element={<PrivateRoute rol="staff"><Maquinistas /></PrivateRoute>} />
      <Route path="/maquinista/inicio" element={<PrivateRoute rol="maquinista"><LayoutMaquinista><Inicio /></LayoutMaquinista></PrivateRoute>} />
      <Route path="/maquinista/nuevo-servicio" element={<PrivateRoute rol="maquinista"><LayoutMaquinista><Inicio /></LayoutMaquinista></PrivateRoute>} />
      <Route path="/maquinista/proximos" element={<PrivateRoute rol="maquinista"><LayoutMaquinista><ProximosServicios /></LayoutMaquinista></PrivateRoute>} />
      <Route path="/maquinista/habilitaciones" element={<PrivateRoute rol="maquinista"><LayoutMaquinista><Habilitaciones /></LayoutMaquinista></PrivateRoute>} />
      <Route path="/maquinista/documentacion" element={<PrivateRoute rol="maquinista"><LayoutMaquinista><Documentacion /></LayoutMaquinista></PrivateRoute>} />
      <Route path="/maquinista/servicio/:id" element={<PrivateRoute rol="maquinista"><Servicio /></PrivateRoute>} />
      <Route path="/" element={
        usuario
          ? usuario.rol === 'staff'
            ? <Navigate to="/staff/dashboard" replace />
            : <Navigate to="/maquinista/nuevo-servicio" replace />
          : <Navigate to="/login" replace />
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
